import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { UnstyledButton } from '@src/components/Button/Button'

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;

  border-radius: 4px;
  margin-bottom: 16px;
  padding: 12px 16px;
  background-color: #f6f6f9;
`

export const SectionTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
`
export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  white-space: pre-wrap;
  font-size: 15px;
`

export const TextList = styled.div`
  margin-right: 4px;
`

export const StyledLink = styled(Link)`
  text-decoration: underline;
  font-size: 15px;

  &:hover {
    text-decoration: none;
  }
`

export const LoyaltyCardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const LoyaltyInfoContainer = styled.div`
  margin-bottom: 24px;
  border: 2px solid #ebecf0;
  padding: 16px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
`
export const LoyaltyCardHowManyStampsAwayText = styled.div`
  flex-direction: row;
  font-size: 13px;
  white-space: pre-wrap;
  line-height: 18px;
  text-align: left;
  margin-top: 8px;
`

export const StampItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
`

export const StampRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`

export const StampedAmount = styled.span`
  flex: 1;
  text-align: right;
`
export const StampNote = styled.div`
  font-size: 14px;
  color: #666;
  margin-top: 4px;
  font-style: italic;
`

export const StampedOrderNumber = styled.span`
  display: flex;
  flex-grow: 3;
  text-align: left;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`

export const StampedOrderLink = styled(UnstyledButton)`
  width: 100%;
  text-align: left;
`

export const ProgressMeterContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin: 16px 0;
`
